import clsx from "clsx";
import { ButtonGroup, Button as ButtonItem } from "flowbite-react";
import { Text } from "../../../../tailwind/text";

export default function ButtonToggleGroup({
  label,
  options,
  selectedValue,
  onSelect,
  className,
}) {
  return (
    <div className={clsx(className)}>
      <Text className="font-bold mt-5">{label}</Text>
      <ButtonGroup className="mt-3" data-testid={label}>
        {options.map((option) => {
          const isSelected = selectedValue === option.value;
          return (
            <ButtonItem
              data-testid={`button-${option.value}`}
              key={option.value}
              type="button"
              color="alternative"
              onClick={() => onSelect(option.value)}
              className={clsx(
                "border-[1px] border-gray-300 bg-transparent text-gray-800 hover:bg-gray-200 hover:text-gray-900 transition duration-200",
                isSelected && "bg-gray-200 text-gray-900",
              )}
            >
              {option.label}
            </ButtonItem>
          );
        })}
      </ButtonGroup>
    </div>
  );
}
